import React from 'react';
import './AnalyticsContextBanner.css';

const VARIANT_CONFIG = {
  window: { icon: '📅', label: 'Observation window' },
  metrics: { icon: '📊', label: 'Metrics' },
  engine: { icon: '⚙️', label: 'Calculation' },
  status: { icon: 'ℹ️', label: 'Status scope' },
  risk: { icon: '⚠️', label: 'Risk scoring' },
};

/**
 * Prominent context callout for analytics sections (12-mo window, engine alignment, etc.).
 */
function AnalyticsContextBanner({
  variant = 'window',
  title,
  children,
  compact = false,
  className = '',
}) {
  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.window;
  const displayTitle = title || config.label;

  return (
    <div
      className={[
        'analytics-context-banner',
        `analytics-context-banner--${variant}`,
        compact ? 'analytics-context-banner--compact' : '',
        className,
      ].filter(Boolean).join(' ')}
      role="note"
    >
      <div className="analytics-context-banner__accent" aria-hidden="true" />
      <div className="analytics-context-banner__icon-wrap" aria-hidden="true">
        <span className="analytics-context-banner__icon">{config.icon}</span>
      </div>
      <div className="analytics-context-banner__content">
        <div className="analytics-context-banner__title">{displayTitle}</div>
        <div className="analytics-context-banner__body">{children}</div>
      </div>
    </div>
  );
}

export default AnalyticsContextBanner;
